import React from 'react';
import { Navigate } from 'react-router-dom';
import { URLS } from '../../router-x/routes';

const Settings = () => {
    return <Navigate to={URLS.ADMIN.SETTINGS_MEETING_ROOM} replace />;
};

export default Settings;